import type { SxProps, Theme } from "@mui/material/styles";
import { MUI_TOOLTIP } from "@constants/mui.constants";

/** Above select menus (`defaultSelectMenuProps` uses 10001). */
export const APP_TOOLTIP_POPPER_Z_INDEX = 10002;

export const appTooltipSx: SxProps<Theme> = {
	backgroundColor: MUI_TOOLTIP.TOOLTIP_BACKGROUND_COLOR,
	color: MUI_TOOLTIP.TOOLTIP_COLOR,
	fontSize: MUI_TOOLTIP.TOOLTIP_FONT_SIZE,
	padding: MUI_TOOLTIP.TOOLTIP_PADDING,
	borderRadius: MUI_TOOLTIP.TOOLTIP_BORDER_RADIUS,
	maxWidth: MUI_TOOLTIP.TOOLTIP_MAX_WIDTH,
	boxShadow: MUI_TOOLTIP.TOOLTIP_BOX_SHADOW,
	fontFamily: MUI_TOOLTIP.TOOLTIP_FONT_FAMILY,
	letterSpacing: MUI_TOOLTIP.TOOLTIP_LETTER_SPACING,
	lineHeight: MUI_TOOLTIP.TOOLTIP_LINE_HEIGHT,
	"& .MuiTooltip-arrow": {
		color: MUI_TOOLTIP.TOOLTIP_BACKGROUND_COLOR,
	},
};

export function getAppTooltipComponentsProps(tooltipSx?: SxProps<Theme>) {
	return {
		tooltip: {
			sx: { ...appTooltipSx, ...(tooltipSx ?? {}) },
		},
		popper: {
			sx: { zIndex: APP_TOOLTIP_POPPER_Z_INDEX },
		},
	};
}
